<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title">One for the Gods</p>
<p class="sub-title">The Peter &amp; Charlie Trilogy</p>
<p class="authorname">Gordon Merrick</p>
<p class="publisher"><img alt="image" class="svg" src="images/fig_02.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?312533d3